'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _getWidgetStartOpen = require('../../widget-ui/selectors/getWidgetStartOpen');

var _getWidgetDataAsyncData = require('../../widget-data/selectors/getWidgetDataAsyncData');

var _getThreadsAsyncData = require('../../threads/selectors/getThreadsAsyncData');

var _Checker = require('../components/Checker');

var _Checker2 = _interopRequireDefault(_Checker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    startOpen: (0, _getWidgetStartOpen.getWidgetStartOpen)(state),
    threadsAsyncData: (0, _getThreadsAsyncData.getThreadsAsyncData)(state),
    widgetDataAsyncData: (0, _getWidgetDataAsyncData.getWidgetDataAsyncData)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Checker2.default);
module.exports = exports['default'];